import { CreateNewForecastPayload, ForecastUpdatePayload } from '../../predict/src/forecast/dashboard/types';
import { createNewForecast, deleteForecast, updateForecast } from '../../predict/src/core/api/forecast';
import { clearSubEntityForecastsQueryCache } from '../queries/consolidatedForecasts';
import { createMutation } from '../utils/mutations';
import { forecastsQueryKey } from '../queries/forecasts';
import { queryClient } from '../core/queryClient';

type CreateForecastResult = Awaited<ReturnType<typeof createNewForecast>>;
type DeleteForecastResult = Awaited<ReturnType<typeof deleteForecast>>;
type UpdateForecastResult = Awaited<ReturnType<typeof updateForecast>>;

export const createForecastMutation = (workspaceId: string, organisationId: string) => {
  return createMutation<CreateNewForecastPayload, CreateForecastResult>({
    mutationFn: data => createNewForecast(workspaceId, organisationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: forecastsQueryKey(organisationId, workspaceId) });
      clearSubEntityForecastsQueryCache();
    }
  });
};

export const deleteForecastMutation = (workspaceId: string, organisationId: string) =>
  createMutation<string, DeleteForecastResult>({
    mutationFn: forecastId => deleteForecast(workspaceId, organisationId, forecastId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: forecastsQueryKey(organisationId, workspaceId) });
    }
  });

export const updateForecastMutation = (workspaceId: string, organisationId: string) =>
  createMutation<{ forecastId: string; data: ForecastUpdatePayload }, UpdateForecastResult>({
    mutationFn: input => updateForecast(input.data, workspaceId, organisationId, input.forecastId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: forecastsQueryKey(organisationId, workspaceId) });
      clearSubEntityForecastsQueryCache();
    }
  });
